import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { removeUserSession } from "../../utils/Common";
// import { getUser } from '../../utils/Common';
import PrivateRoute from "../../utils/PrivateRoute";
import Dashboard from "./Dashboard";
import CatalogoArticulos from "./catalogos/CatalogoArticulos";
import CatalogoFloresVariedadColores from "./catalogos/FloresVariedadesColores/CatalogoFloresVariedadColores.jsx";
import Navigation from "./Navigation";
import NuevaFlor from "./catalogos/NuevaFlor";
import CatalogoColores from "./catalogos/CatalogoColores";
import ApellidosFlor from "./catalogos/ApellidosFlor";
import ImagenFlor from "./catalogos/ImagenFlor";
import InfoFlor from "./catalogos/InfoFlor";
import CatalogoRanchos from "./ranchos/CatalogoRanchos";
import AltaRancho from "./ranchos/AltaRancho";
import PlanCosecha from "./planes/PlanCosecha";
import PlanCosechaGenerados from "./planes/PlanCosechaGenerados";
import PlanSiembra from "./planes/PlanSiembra";
import EditarFlor from "./catalogos/EditarFlor";
import LaboresFlor from "./catalogos/LaboresFlor";
// import PlanesEjecucion from "./planes/PlanesEjecucion";
import PlanLabores from "./planes/PlanLabores";
import EjecucionSiembra from "./planes/EjecucionSiembra";
import AsignacionValvulas from "./planes/AsignacionValvulas";
import RpteSiembraSemanal from "./reportes/RpteSiembraSemana";
import SeleccionCamas from "./planes/SeleccionCamas";
import VerAsignacionesValvula from "./planes/VerAsignacionesValvula";
import RpteSiembraEjecutada from "./reportes/RpteSiembraEjecutada";
import CatalogoFlores from "./catalogos/CatalogoFlores";
import InfoRancho from "./ranchos/InfoRancho";
import InventarioCampo from "./reportes/InventarioCampo";
// import FlorPlan from "./planes/FlorPlan";
import PorcentajesPlan from "./planes/PorcentajesPlan";
import FlorPlanporcentajes from "./planes/FlorPlanporcentajes";
import InvVivero from './inventarios/InvVivero.js';
import Gradosdias from "./Gradosdias";
import CatalogoTipoFlores from "./catalogos/CatalogoTipoFlores";
import RpteFertilizacion from "./reportes/RpteFertilizacion";
import RpteCosecha from "./reportes/RpteCosecha";
import InventarioVivero from "./reportes/InventarioVivero";
import AreasNomina from "./nomina/AreasNomina";
import InventarioActividades from "./nomina/InventarioActividades";
import ReporteHoras from "./nomina/ReporteHoras";
import InvAclimatacion from "./inventarios/InvAclimatacion";
import PlanesEjecucion from "./planes/PlanesEjecucion";
import Sensores_data from "./sensores/sensores_data";
import InventarioLabores from "./nomina/InventarioLabores";
import Etiquetas_vivero from "./etiquetas/etiquetas_vivero";
import Actividades_vivero from "./reportes/vivero/actividades_vivero.js";
import Settings from "./settings/Settings.jsx";

//vivero
import ReporteSemilla from "./Vivero/ReporteSemilla.jsx";
import OrdenesTrabajoSiembra from "./Vivero/OrdenesTrabajoSiembra.jsx";

//catalogos
import Rendimientos_catalogo from "./catalogos/V2/Rendimientos_catalogo.jsx";
import CatalogoValvulas from "./catalogos/V2/Valvulas/CatalogoValvulas.jsx";
import VirusEnfermedadesCatalogo from "./catalogos/VirusEnfermedadesCatalogo/VirusEnfermedadesCatalogo.jsx";

//pantallas de campo V2
import PlaneacionCampo from "./campo/planeacionCampo/PlaneacionCampo.jsx";
import InventarioCampoV2 from "./campo/InventarioCampoV2/InventarioCampoV2.jsx";
import GradosDiasV2 from "./campo/GradosDias/GradosDiasV2.jsx";
import NETJET from "./campo/NETJET/NETJET.jsx";
import NETJETriego from "./campo/NETJETriego/NETJETriego.jsx";
import EjecucionInventarioCampo from "./campo/EjecucionInventarioCampo/EjecucionInventarioCampo.jsx";
import ReporteEjecucionPlanCampo from "./campo/ReporteEjecucionPlanCampo/ReporteEjecucionPlanCampo.jsx";
import CargasTemperaturaExcel from "./campo/CargasTemperaturaExcel/CargasTemperaturaExcel.jsx";
import SiembraDirecta from "./campo/SimebraDirecta/SiembraDirecta.jsx";
import ConteosCampo from "./campo/ConteosCampo/ConteosCampo.jsx";
import PlanCampoExternoExcel from "./nomina/PlanCampoExternoExcel.jsx";
import CargaRevisionLaboresExcel from "./catalogos/CargaLaboresExcel/CargaRevisionLaboresExcel.jsx";
import OrdenesTrabajoOperativoCampo from "./campo/OrdenesTrabajo/OrdenesTrabajoOperativoCampo.jsx";
import Proyecciones from "./campo/Proyecciones/Proyecciones.jsx";
import Rpt_ejecucion_siembra from "./reportes/rpt_ejecucion_siembra/rpt_ejecucion_siembra.jsx";
import Rpt_ejecucion_trasplante from "./reportes/rpt_ejecucion_trasplante/Rpt_ejecucion_trasplante.jsx";
import ActividadesNomina from "./nomina/actividades_nomina/ActividadesNomina.jsx";

//pantallas de MIPE v2
import MIPEmonitoreo from "./MIPE/MIPEmonitoreo.jsx";

function Main(props) {
   // const user = getUser();
   // handle click event of logout button
   const handleLogout = () => {
      removeUserSession();
      props.history.push("/login");
   };
   return (
      <>
         <Navigation logout={handleLogout} />
         <div className="col-lg-12 p-0 bg-light ps-0 pb-0 pe-0 p-1" style={{ height: 'calc(100vh - 50px)', marginTop: '50px', overflow: 'auto' }}>
            <Switch>
               <Route exact path="/">
                  <Redirect to="/dashboard" />
               </Route>
               <PrivateRoute path="/dashboard" component={Dashboard} />
               {/* Rutas para el catalogo de flores */}
               <PrivateRoute path="/catalogo_articulos" component={CatalogoArticulos} />
               <PrivateRoute path="/catalogo_tipo_flor" component={CatalogoTipoFlores} />
               <PrivateRoute path="/nueva_flor" component={NuevaFlor} />
               <PrivateRoute path="/editar_flor/:id" component={EditarFlor} />
               <PrivateRoute path="/imagen_flor/:id" component={ImagenFlor} />
               <PrivateRoute path="/info_flor/:id" component={InfoFlor} />
               <PrivateRoute path="/labores/:id" component={LaboresFlor} />
               <PrivateRoute path="/catalogo_colores" component={CatalogoColores} />
               <PrivateRoute path="/catalogo_flores" component={CatalogoFloresVariedadColores} />
               <PrivateRoute path="/catalogos/valvulas" component={CatalogoValvulas} />
               <PrivateRoute path="/variedades" component={ApellidosFlor} />
               {/* /.Rutas para el catalogo de flores */}
               {/** Rutas para los Ranchos */}
               <PrivateRoute path="/ranchos" component={CatalogoRanchos} />
               <PrivateRoute path="/ranchos_alta" component={AltaRancho} />
               <PrivateRoute path="/info_rancho/:id" component={InfoRancho} />
               {/** ./Rutas para los Ranchos */}
               {/** Rutas para el PLan de Cosecha */}
               <PrivateRoute path="/flor_plan" component={FlorPlanporcentajes} />
               <PrivateRoute path="/porcentajes_plan/:id/:year/:flor" component={PorcentajesPlan} />
               <PrivateRoute path="/plan_cosecha" component={PlanCosecha} />
               <PrivateRoute path="/plan_cosecha_generados" component={PlanCosechaGenerados} />
               <PrivateRoute path="/plan_siembra" component={PlanSiembra} />
               <PrivateRoute path="/planes_iniciados" component={PlanesEjecucion} />
               {/*<PrivateRoute path='/planes_iniciados' component={PlanesEjecucionv2} />*/}
               <PrivateRoute path="/plan_siembra_semanal" component={EjecucionSiembra} />
               <PrivateRoute path="/plan_labores" component={PlanLabores} />
               {/** ./Rutas para el PLan de Cosecha */}
               {/* Inventarios */}

               <PrivateRoute path="/rpte_inventario_campo_anterior" component={InventarioCampo} />

               {/*<PrivateRoute path="/rpte_inventario_campo" component={InvCampo} />*/}
               <PrivateRoute path="/rpte_inventario_vivero" component={InventarioVivero} />
               <PrivateRoute path="/inventario_aclimatacion" component={InvAclimatacion} />
               {/** Rutas de Reportes */}
               <PrivateRoute path="/rpte_siembra_semanal" component={RpteSiembraSemanal} />
               <PrivateRoute path="/rpte_aclimatacion_entrega" component={RpteSiembraEjecutada} />
               <PrivateRoute path="/rpte_fertilizacion" component={RpteFertilizacion} />
               <PrivateRoute path="/rpte_cosecha" component={RpteCosecha} />
               <PrivateRoute path="/rpt_ejecucion_siembra" component={Rpt_ejecucion_siembra} />
               <PrivateRoute path="/rpt_ejecucion_trasplante" component={Rpt_ejecucion_trasplante} />
               {/** ./Rutas de Reportes */}
               {/* asignacion de valvulas */}
               <PrivateRoute path="/asignacion_valvulas/:id" component={AsignacionValvulas} />
               <PrivateRoute path="/asignacion_camas/:id/:v" component={SeleccionCamas} />
               <PrivateRoute path="/ver_asignaciones/:id" component={VerAsignacionesValvula} />
               {/* ./asignacion de valvulas */}

               {/* asignacion de valvulas */}
               <PrivateRoute path="/inentario/vivero" component={InvVivero} />
               {/** Configuración de los grados días */}

               {/** Nómina de campo **/}
               <PrivateRoute path="/nomina/rendimientos" component={Rendimientos_catalogo} />
               <PrivateRoute path="/nomina/areas" component={AreasNomina} />
               <PrivateRoute path="/nomina/inventario" component={InventarioActividades} />

               {/*<PrivateRoute path="/nomina/alta-inventario" component={AgregarInventario} />*/}
               <PrivateRoute path="/nomina/alta-inventario" component={InventarioLabores} />

               <PrivateRoute path="/nomina/reporte-horas/:id" component={ReporteHoras} />

               {/** ./Nómina de campo **/}
               <PrivateRoute path="/actividades_nomina" component={ActividadesNomina} />

               {/* Datos de Sensores */}
               <PrivateRoute path="/sensores" component={Sensores_data} />
               {/* ./Datos de Sensores */}

               {/*Página para generar etiquetas para vivero */}
               <PrivateRoute path="/etiquetas_vivero" component={Etiquetas_vivero} />
               <PrivateRoute path="/reporte_actividades_vivero" component={Actividades_vivero} />
               <PrivateRoute path="/settings" component={Settings} />
               <PrivateRoute path="/catalogos/rendimientos" component={Rendimientos_catalogo} />
               <PrivateRoute path="/catalogos_virus_enfermedades" component={VirusEnfermedadesCatalogo} />
               <PrivateRoute path="/catalogos_virus_enfermedades" component={VirusEnfermedadesCatalogo} />
               <PrivateRoute path="/cargas/labores" component={CargaRevisionLaboresExcel} />

               {/* PAGINAS DE CAMPO */}
               <PrivateRoute path="/planeacion-campo" component={PlaneacionCampo} />
               <PrivateRoute path="/rpte_inventario_campo" component={InventarioCampoV2} />
               <PrivateRoute exact path="/gradosdias" component={GradosDiasV2} />
               <PrivateRoute exact path="/gradosDias/cargarExcel" component={CargasTemperaturaExcel} />
               <PrivateRoute exact path="/reportes/netjet" component={NETJETriego} />
               <PrivateRoute path="/aplicacion/refuerzos" component={NETJET} />
               <PrivateRoute path="/campo/ejecucion" component={EjecucionInventarioCampo} />
               <PrivateRoute exact path="/reportes/ejecucionPlanCampo" component={ReporteEjecucionPlanCampo} />
               <PrivateRoute exact path="/campo/siembraDirecta" component={SiembraDirecta} />
               <PrivateRoute path="/reporte-semilla" component={ReporteSemilla} />
               <PrivateRoute path="/ordenes-trabajo" component={OrdenesTrabajoSiembra} />
               <PrivateRoute path="/campo/conteos" component={ConteosCampo} />
               <PrivateRoute path="/campo/inventario/externo" component={PlanCampoExternoExcel} />
               <PrivateRoute path="/campo/proyecciones" component={Proyecciones} />
               <PrivateRoute path="/campo/ordenes_trabajo_campo" component={OrdenesTrabajoOperativoCampo} />

               {/* PAGINAS DE MIPE*/}
               <PrivateRoute path="/MIPE/monitoreo" component={MIPEmonitoreo} />
            </Switch>
         </div>

      </>
   );
}
export default Main;
